import { apiClient } from "../config/api.config";
import { Facility, FacilityUpdate } from "../types/facility.definition";

export function getHealthcareFacilityById(id: number) {
  return apiClient.request({
    method: "get",
    url: `/healthcare-facilities/${id}`,
  });
}

export function getStaffStatsByFacilityId(id: number) {
  return apiClient.request({
    method: "get",
    url: `/healthcare-facilities/${id}/staff/stats`,
  });
}

export async function getHealthcareFacilities() {
  return apiClient.request({
    method: "get",
    url: `/healthcare-facilities`,
  });
}
export async function searchHealthcareFacilities() {
  return apiClient.request({
    method: "get",
    url: `/healthcare-facilities/search`,
  });
}
export function updateHealthcareFacility(data: Partial<FacilityUpdate>, id: number) {
  return apiClient.request({
    method: "put",
    url: `/healthcare-facilities/${id}`,
    data,
  });
}

export function createHealthcareFacility(data: Facility, id: number) {
  return apiClient.request({
    method: "put",
    url: `/healthcare-facilities/${id}`,
    data,
  });
}

export function getHealthcareFacilityDoctors(facilityId: number) {
  return apiClient.request({
    method: "get",
    url: `/healthcare-facilities/${facilityId}/doctors`,
  });
}

export function getWorkingDoctorsTodayByFacility(facilityId: number) {
  return apiClient.request({
    method: "get",
    url: `/healthcare-facilities/${facilityId}/working-doctors-today`,
  });
}

export function getHealthcareFacilityPatients(facilityId: number) {
  return apiClient.request({
    method: "get",
    url: `/healthcare-facilities/${facilityId}/patients`,
  });
}

export function getHealthcareFacilityAppointments(facilityId: number) {
  return apiClient.request({
    method: "get",
    url: `/healthcare-facilities/${facilityId}/appointments`,
  });
}
export function getHealthcareFacilityStatistics(facilityId: number) {
  return apiClient.request({
    method: "get",
    url: `/healthcare-facilities/${facilityId}/statistics`,
  });
}

export function getHealthcareFacilityTodaySchedule(facilityId: number) {
  return apiClient.request({
    method: "get",
    url: `/healthcare-facilities/${facilityId}/today-schedule`,
  });
}

export function getHealthcareFacilityRecentActivities(facilityId: number) {
  return apiClient.request({
    method: "get",
    url: `/healthcare-facilities/${facilityId}/recent-activities`,
  });
}

export function getHealthcareFacilityAlerts(facilityId: number) {
  return apiClient.request({
    method: "get",
    url: `/healthcare-facilities/${facilityId}/alerts`,
  });
}

export function getHealthcareFacilityDashboardAnalytics(
  facilityId: number,
  timePeriod: string = "all"
) {
  return apiClient.request({
    method: "get",
    url: `/healthcare-facilities/${facilityId}/dashboard-analytics`,
    params: {
      timePeriod,
    },
  });
}
